var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkclick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M765.446+61.6434L265.335+61.6434C225.897+61.6434+193.89+99.1672+193.89+145.402L193.89+942.778C193.89+964.984+207.558+971.271+224.419+956.819L485.836+732.75C502.697+718.298+529.998+718.339+546.815+732.841L806.44+956.728C823.257+971.23+836.89+964.984+836.89+942.778L836.89+145.402C836.89+99.1672+804.883+61.6434+765.446+61.6434Z",
    opacity: 1,
    fill: "#5fe1d8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M607.532+335.182L714.704+338.198C734.434+338.753+737.78+349.283+722.178+361.717L637.037+429.569C621.435+442.003+613.287+467.877+618.838+487.36L649.331+594.382C654.882+613.864+646.216+620.307+629.974+608.772L541.409+545.872C525.167+534.337+498.835+534.339+482.596+545.878L394.022+608.812C377.782+620.35+369.118+613.911+374.669+594.428L405.162+487.406C410.713+467.923+402.565+442.05+386.963+429.615L301.822+361.763C286.22+349.329+289.566+338.799+309.296+338.244L416.468+335.228C436.198+334.673+457.512+318.701+464.073+299.553L500.12+194.361C506.681+175.213+517.32+175.213+523.883+194.36L559.924+299.508C566.487+318.655+587.802+334.627+607.532+335.182Z",
    fill: "#ffe34a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkclick);
export default __webpack_public_path__ + "static/media/Bookmark click.2a26daef373854d539b23457a814474d.svg";
export { ForwardRef as ReactComponent };